import React, { useState, useEffect } from "react";
import Seo from "../../../shared/ui/Seo";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../../cart/context/CartContext";
import { saveGusetCustomerOrder, getBuyNow, getBuyNowTotal, clearBuyNow } from "../api";
import { getProductsByListOfIds } from "../../products/api";
import { validateGuestCoupon } from "../../coupons/api";
import Select from 'react-select';

import { toast } from "react-toastify";
import { onePayCheckout } from "../payments/onePay";
import { S3_URL_PRODUCTS } from "../../../shared/utils/constants";
import { kokoPay } from "../payments/kokoPay";
import { sriLankanDistricts } from "../../../shared/utils/constants";
import { parseWeight } from "../utils/deliveryFee";
import { getEffectivePrice, formatPrice } from "../utils/pricing";
import useDeliveryFee from "../hooks/useDeliveryFee";
import useKokoTaxRate from "../hooks/useKokoTaxRate";
import DeliveryFeeAmount from "./DeliveryFeeAmount";
import CheckoutSteps from "./CheckoutSteps";
import PaymentOptions from "./PaymentOptions";
import { CouponField, CouponTicket } from "../../coupons/components/CouponTicket";
import "../../../shared/styles/cart-checkout.css";
const GuestCheckout = () => {
  // const [selectedPayment, setSelectedPayment] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("payment3");
  const [isCardPaymentsExpanded, setIsCardPaymentsExpanded] = useState(false);
  const [selectedCardPayment, setSelectedCardPayment] = useState("");
  const { clearCartAfterCheckout } = useCart();
  const [items, setItems] = useState([]);
  const [isCartLoaded, setIsCartLoaded] = useState(false);
  const [total, setTotal] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponDetails, setCouponDetails] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address_1: "",
    city: "",
    state: "",
    postCode: "",
    phone: "",
    phone2: "",
    email: "",
    customerNote: "",
  });

  const handleChangePhone = (e) => {
    const phone = e.target.value;
    const isValid = /^0[0-9]{9}$/.test(phone);

    setFormData((prev) => ({ ...prev, phone }));

    // Guest coupons are issued per phone number, so a new number invalidates it
    if (couponDetails) {
      setCouponDetails(null);
      setCouponError("Phone number changed. Please apply your coupon again.");
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      phone: !isValid && phone.length > 0 ? "Must be 10 digits and start with 0" : "",
    }));
  };
  const handleChangePhone2 = (e) => {
    const phone2 = e.target.value;
    const isValid = /^0[0-9]{9}$/.test(phone2);

    setFormData((prev) => ({ ...prev, phone2 }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      phone2: !isValid && phone2.length > 0 ? "Must be 10 digits and start with 0" : "",
    }));
  };

  useEffect(() => {
    return () => {
      if (window.location.pathname !== "/checkout") {
        clearBuyNow();
      }
    };
  }, []);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const buyNowProduct = getBuyNow();
        if (buyNowProduct) {
          setItems([buyNowProduct]);
          setTotal(getBuyNowTotal());
          setIsCartLoaded(true);
          return;
        }

        const cartItems = JSON.parse(localStorage.getItem("cart")) || [];

        if (cartItems.length > 0) {
          const productIds = cartItems.map((item) => item.id);
          const response = await getProductsByListOfIds(productIds);
          const productsFromApi = Array.isArray(response)
            ? response
            : response.products;
          if (!productsFromApi || productsFromApi.length === 0) {
            return [];
          }
          const productData = cartItems.map((item) => {
            const prodId = item.id;
            const productWrapper = productsFromApi.find(
              (p) => p.product.id === prodId
            );
            if (!productWrapper) return null;
            const product = productWrapper.product;
            return {
              id: product.id,
              name: product.name,
              images: product.images,
              salePrice: product.salePrice,
              regularPrice: product.regularPrice,
              stockQuantity: product.stockQuantity,
              quantity: item.quantity,
              sku: product.sku,
              configuration: product.configuration || null,
              nonCod: product.nonCod || false,
              weight: parseWeight(product.weight),
            };
          });

          const filteredProducts = productData.filter((p) => p !== null);
          setItems(filteredProducts);
          setTotal(
            filteredProducts.reduce((sum, item) => {
              const config = item.configuration;
              const configDiscount =
                config?.Sale?.collectionConfiguration?.discount || 0;
              const discountActive =
                config &&
                configDiscount &&
                config?.Sale?.configStatus === "active";

              let effectivePrice;
              if (discountActive) {
                if (item.salePrice) {

                  effectivePrice = item.salePrice * (1 - configDiscount / 100);
                } else {
                  // Case 3: Active config but no salePrice; calculate effective price from regularPrice.
                  effectivePrice =
                    item.regularPrice * (1 - configDiscount / 100);
                }
              } else {
                // Cases 2 & 4: No active config; use salePrice if available, otherwise regularPrice.
                effectivePrice = item.salePrice || item.regularPrice;
              }
              return sum + item.quantity * effectivePrice;
            }, 0)
          );
        }

        setIsCartLoaded(true);

        // If no items are found, redirect to home.
        if (cartItems.length === 0) {
          navigate("/");
        }
      } catch (error) {
        console.error("Error loading cart:", error);
        setIsCartLoaded(true);
        navigate("/");
      }
    };

    fetchItems();
  }, [navigate]);

  const { kokoTaxRate, kokoTaxRateStatus } = useKokoTaxRate();
  const {
    deliveryFee,
    deliveryFeeStatus,
    loadDeliveryFee,
    ensureDeliveryFee,
  } = useDeliveryFee(
    items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      weight: item.weight,
    }))
  );

  useEffect(() => {
    if (selectedPayment === "payment5") {
      const handleOnePaySuccess = (e) => {
        const buyNow = getBuyNow();
        if (buyNow) {
          clearBuyNow();
        } else {
          clearCartAfterCheckout();
        }
        navigate("/");
      };

      const handleOnePayFail = (e) => {
        navigate("/");
      };

      window.addEventListener("onePaySuccess", handleOnePaySuccess);
      window.addEventListener("onePayFail", handleOnePayFail);

      return () => {
        window.removeEventListener("onePaySuccess", handleOnePaySuccess);
        window.removeEventListener("onePayFail", handleOnePayFail);
      };
    }
  }, [selectedPayment, navigate, clearCartAfterCheckout]);

  const handlePaymentChange = (e) => {
    const payment = e.target.value;
    setSelectedPayment(payment);
    // When Card Payments is selected, expand its options.
    if (payment === "cardPayments") {
      setIsCardPaymentsExpanded(true);
    } else {
      setIsCardPaymentsExpanded(false);
    }
  };
  const handleCardPaymentChange = (e) => {
    setSelectedCardPayment(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error immediately as user types
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const [errors, setErrors] = useState({});

  const isValidPhone = (phone) => /^0[0-9]{9}$/.test(phone);

  // Guest coupons are issued per phone number, so that's all a coupon needs.
  const canApplyCoupon = isValidPhone(formData.phone);

  const handleApplyCoupon = async () => {
    const code = couponCode.trim();
    if (!code || !canApplyCoupon || isApplyingCoupon) return;

    setIsApplyingCoupon(true);
    setCouponError("");
    try {
      const data = await validateGuestCoupon(formData.phone, code);
      if (!data || data.status !== "ACTIVE") {
        setCouponError("This coupon is not active.");
        return;
      }
      if (data.expirationDate && new Date(data.expirationDate) < new Date()) {
        setCouponError("This coupon has expired.");
        return;
      }
      setCouponDetails(data);
      toast.success("Coupon applied successfully");
    } catch (error) {
      console.error("Error applying coupon:", error);
      setCouponError(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "This coupon is not valid for this phone number."
      );
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const handleRemoveCoupon = () => {
    setCouponDetails(null);
    setCouponCode("");
    setCouponError("");
  };

  // Coupon discount applies to the whole order subtotal (all items together)
  const discount = !couponDetails
    ? 0
    : couponDetails.couponType === "PERCENTAGE"
      ? total * (Math.min(couponDetails.discountedValue, 100) / 100)
      : Math.min(couponDetails.discountedValue, total);

  // A single non-COD item in the order rules out cash on delivery.
  const hasNonCodItem = items.some((item) => item.nonCod);

  useEffect(() => {
    if (hasNonCodItem && selectedPayment === "payment3") {
      setSelectedPayment("cardPayments");
      setIsCardPaymentsExpanded(true);
      setSelectedCardPayment("payment5");
    }
  }, [hasNonCodItem, selectedPayment]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prevent double click / duplicate order submission
    if (isSubmitting) return;

    const newErrors = {};

    if (!formData.firstName) newErrors.firstName = "First name is required !";
    if (!formData.lastName) newErrors.lastName = "Last name is required !";
    if (!formData.address_1) newErrors.address_1 = "Street address is required !";
    if (!formData.state) newErrors.state = "District is required !";
    if (!formData.city) newErrors.city = "City is required !";
    if (!formData.phone) newErrors.phone = "Phone number 01 is required !";
    if (!formData.phone2) newErrors.phone2 = "Phone number 02 is required !";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    if (hasNonCodItem && selectedPayment === "payment3") {
      toast.error(
        "Cash on delivery isn't available for this order. Please choose another payment method."
      );
      return;
    }
    if (selectedPayment === "payment6" && kokoTaxRate === null) {
      toast.error("Unable to load the KOKO Pay tax rate. Please try again.");
      return;
    }

    setIsSubmitting(true);

    const fee = await ensureDeliveryFee();
    if (fee === null) {
      setIsSubmitting(false);
      return;
    }

    const paymentMethodMap = {
      payment3: "COD",
      payment4: "payhere",
      payment5: "onePay",
      payment6: "kokoPay",
    };

    const lineItems = items.map((item) => ({
      productId: item.id,
      quantity: item.quantity,
      salePrice: item.salePrice || item.regularPrice,
    }));

    const orderDTO = {
      paymentMethod:
        selectedPayment === "cardPayments"
          ? paymentMethodMap[selectedCardPayment]
          : paymentMethodMap[selectedPayment],

      customerId: null,

      billing: {
        first_name: formData.firstName,
        last_name: formData.lastName,
        address_1: formData.address_1,
        city: formData.city,
        state: formData.state,
        postCode: formData.postCode,
        country: "Sri Lanka",
        phone: formData.phone,
        phone2: formData.phone2,
        email: formData.email,
      },

      lineItems,
      shippingLines: null,
      couponLines: couponDetails
        ? [
            {
              code: couponDetails.couponCode,
              discount: discount.toFixed(2),
            },
          ]
        : null,
      customerNote: formData.customerNote || null,

      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phone,
      phoneNumber2: formData.phone2,

      totalPrice: total.toFixed(2),
      deliveryFee: fee.toFixed(2),
      discount: discount,
      kokoTax: kokoTax.toFixed(2),
    };

    try {
      const response = await saveGusetCustomerOrder(orderDTO);

      if (
        selectedPayment === "cardPayments" &&
        selectedCardPayment === "payment4"
      ) {
        const { customOrderId, payHereDTO } = response.object;

        const payment = {
          sandbox: process.env.REACT_APP_PAYHERE_SANDBOX,
          merchant_id: payHereDTO.merchantId,
          return_url: payHereDTO.returnUrl,
          cancel_url: payHereDTO.cancelUrl,
          notify_url: payHereDTO.notifyUrl,
          order_id: customOrderId,
          items: payHereDTO.orderNumber,
          amount: payHereDTO.amount,
          currency: payHereDTO.currency,
          hash: payHereDTO.hash,
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          address: formData.address_1,
          city: formData.city,
          country: "Sri Lanka",
          delivery_address: formData.address_1,
          delivery_city: formData.city,
          delivery_country: "Sri Lanka",
          custom_1: "WEB",
          custom_2: "",
        };

        sessionStorage.setItem("orderId", response.object.customOrderId);

        window.payhere.onCompleted = function (orderId) {
          console.log("Payment completed. OrderID:", orderId);
        };

        window.payhere.onDismissed = function () {
          console.log("Payment dismissed");
          setIsSubmitting(false);
        };

        window.payhere.onError = function (error) {
          console.error("Payment error:", error);
          toast.error("Payment failed.");
          setIsSubmitting(false);
        };

        window.payhere.startPayment(payment);
      } else if (
        selectedPayment === "cardPayments" &&
        selectedCardPayment === "payment5"
      ) {
        const { customOrderId, onePayDTO } = response.object;

        const onePayData = {
          currency: "LKR",
          app_id: onePayDTO.appId,
          amount: onePayDTO.amount,
          reference: `Bigmall-${onePayDTO.generatedOrderId}`,
          customer_first_name: formData.firstName,
          customer_last_name: formData.lastName,
          customer_phone_number: formData.phone,
          customer_email: onePayDTO.email,
          transaction_redirect_url: onePayDTO.transactionRedirectUrl,
          additional_data: customOrderId,
          hash: onePayDTO.hash,
        };

        const responseOnePay = await onePayCheckout(
          onePayData,
          onePayDTO.appToken
        );

        if (responseOnePay.status === 200) {
          sessionStorage.setItem("orderId", response.object.customOrderId);
          sessionStorage.setItem(
            "onePayTransactionId",
            responseOnePay.data.ipg_transaction_id
          );

          const url = responseOnePay.data.gateway.redirect_url;
          window.location.href = url;
        } else {
          console.error("OnePay request failed:", responseOnePay);
          toast.error("OnePay payment failed.");
          setIsSubmitting(false);
        }
      } else if (selectedPayment === "payment6") {
        const { kokoDTO } = response.object;

        const kokoPayData = {
          orderId: kokoDTO.orderId,
          amount: kokoDTO.amount,
          description: kokoDTO.description,
          firstName: kokoDTO.firstName,
          lastName: kokoDTO.lastName,
          email: kokoDTO.email,
          reference: kokoDTO.reference,
          phone: kokoDTO.phone,
          returnUrl: kokoDTO.returnUrl,
          cancelUrl: kokoDTO.cancelUrl,
          responseUrl: kokoDTO.responseUrl,
        };

        sessionStorage.setItem("orderId", kokoDTO.orderId);

        kokoPay(kokoPayData);
      } else {
        toast.success("Order submitted successfully!");

        sessionStorage.setItem("orderId", response.object.customOrderId);

        const redirectUrl = response.object.orderSuccessUrl;
        window.location.href = redirectUrl;
      }
    } catch (error) {
      console.error("Error submitting order:", error);

      let errorMessage = "Something went wrong!";

      if (error.response && error.response.data) {
        errorMessage = error.response.data.message
          ? error.response.data.message
          : JSON.stringify(error.response.data);
      } else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(`Error submitting order: ${errorMessage}`);
      setIsSubmitting(false);
    } finally {
      if (localStorage.getItem("couponDetails")) {
        localStorage.removeItem("couponDetails");
      }
      setIsSubmitting(false);
    }
  };

  if (!isCartLoaded) {
    return <div>Loading...</div>;
  }

  const kokoTax =
    selectedPayment === "payment6" && kokoTaxRate !== null
      ? (total * kokoTaxRate) / 100 // applied to products-only total
      : 0;

  //const grandTotal = total + deliveryFee + kokoTax;

  const handleSelectChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      state: selectedOption ? selectedOption.value : "",
    }));

    // Clear city error as soon as the user selects a district
    if (errors.state) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        state: "",
      }));
    }
  };

  const districtOptions = sriLankanDistricts.map(district => ({
    value: district,
    label: district
  }));

  const renderField = ({ name, label, required, optional, type = "text", placeholder, full, ...inputProps }) => (
    <div className={`bm-field ${full ? "bm-field--full" : ""}`}>
      <label className="bm-label" htmlFor={name}>
        {label}
        {required && <span className="bm-req">*</span>}
        {optional && <span className="bm-opt">(optional)</span>}
      </label>
      <input
        id={name}
        type={type}
        name={name}
        placeholder={placeholder}
        value={formData[name] || ""}
        onChange={handleChange}
        className={`bm-input ${errors[name] ? "is-invalid" : ""}`}
        {...inputProps}
      />
      {errors[name] && <div className="bm-error">{errors[name]}</div>}
    </div>
  );

  return (
    <section className="bm-shop">
      <Seo title="Checkout" noindex />
      <div className="bm-head">
        <h1 className="bm-title">Checkout</h1>
        <CheckoutSteps current={1} />
      </div>

      <div className="bm-banner">
        <i className="ph-fill ph-user-circle" />
        <span>
          Have an account? Sign in for faster checkout and order tracking.{" "}
          <Link to="/login">Register or log in</Link>
        </span>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="bm-grid">
          <div className="bm-stack">
            <div className="bm-card">
              <div className="bm-card__head">
                <h2 className="bm-card__title">
                  Delivery details
                </h2>
              </div>
              <div className="bm-fields">
                {renderField({ name: "firstName", label: "First name", required: true, placeholder: "First name" })}
                {renderField({ name: "lastName", label: "Last name", required: true, placeholder: "Last name" })}
                {renderField({ name: "address_1", label: "Street address", required: true, placeholder: "House no, street", full: true })}
                {renderField({ name: "city", label: "City", required: true, placeholder: "City" })}
                <div className="bm-field">
                  <label className="bm-label" htmlFor="district-select-id">
                    District<span className="bm-req">*</span>
                  </label>
                  <Select
                    inputId="district-select-id"
                    options={districtOptions}
                    value={districtOptions.find((option) => option.value === formData.state) || null}
                    onChange={handleSelectChange}
                    isClearable={true}
                    placeholder="Select district"
                    className={`react-select-container ${errors.state ? "is-invalid" : ""}`}
                    classNamePrefix="react-select"
                  />
                  {errors.state && <div className="bm-error">{errors.state}</div>}
                </div>
                {renderField({ name: "postCode", label: "Postal code", optional: true, placeholder: "Postal code" })}
                {renderField({ name: "email", label: "Email", optional: true, type: "email", placeholder: "you@example.com" })}
                <div className="bm-field">
                  <label className="bm-label" htmlFor="phone">
                    Phone number<span className="bm-req">*</span>
                  </label>
                  <input
                    id="phone"
                    type="tel"
                    placeholder="07xxxxxxxx"
                    name="phone"
                    pattern="0[0-9]{9}"
                    minLength={10}
                    maxLength={10}
                    value={formData.phone || ""}
                    onChange={handleChangePhone}
                    className={`bm-input ${errors.phone ? "is-invalid" : ""}`}
                  />
                  {errors.phone && <div className="bm-error">{errors.phone}</div>}
                </div>
                <div className="bm-field">
                  <label className="bm-label" htmlFor="phone2">
                    Alternate phone number<span className="bm-req">*</span>
                  </label>
                  <input
                    id="phone2"
                    type="tel"
                    placeholder="07xxxxxxxx"
                    name="phone2"
                    pattern="0[0-9]{9}"
                    minLength={10}
                    maxLength={10}
                    value={formData.phone2 || ""}
                    onChange={handleChangePhone2}
                    className={`bm-input ${errors.phone2 ? "is-invalid" : ""}`}
                  />
                  {errors.phone2 && <div className="bm-error">{errors.phone2}</div>}
                </div>
                <div className="bm-field bm-field--full">
                  <label className="bm-label" htmlFor="customerNote">
                    Order notes<span className="bm-opt">(optional)</span>
                  </label>
                  <textarea
                    id="customerNote"
                    className="bm-input"
                    placeholder="Special notes for delivery, e.g. landmarks or preferred time."
                    name="customerNote"
                    value={formData.customerNote}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {items.length > 0 && (
              <div className="bm-card">
                <div className="bm-card__head">
                  <h2 className="bm-card__title">
                    Have a coupon?
                  </h2>
                </div>
                {couponDetails === null ? (
                  <>
                    <CouponField
                      value={couponCode}
                      placeholder={
                        canApplyCoupon
                          ? "Enter coupon code"
                          : "Enter your phone number first"
                      }
                      disabled={!canApplyCoupon || isApplyingCoupon}
                      onChange={(e) => {
                        setCouponCode(e.target.value.toUpperCase());
                        if (couponError) setCouponError("");
                      }}
                      onApply={() => handleApplyCoupon()}
                      applyDisabled={
                        !canApplyCoupon ||
                        couponCode.trim().length === 0 ||
                        isApplyingCoupon
                      }
                      applying={isApplyingCoupon}
                      error={couponError}
                    />
                    {couponError ? (
                      <div className="bm-error">{couponError}</div>
                    ) : (
                      !canApplyCoupon && (
                        <div className="bm-hint">
                          Coupons are linked to your phone number. Enter a valid
                          phone number above to apply one.
                        </div>
                      )
                    )}
                  </>
                ) : (
                  <CouponTicket
                    coupon={couponDetails}
                    onRemove={handleRemoveCoupon}
                  />
                )}
              </div>
            )}
          </div>

          <aside className="bm-stack">
            <div className="bm-card">
              <div className="bm-card__head">
                <h2 className="bm-card__title">
                  Your order
                </h2>
              </div>
              <div className="bm-mini">
                {items.map((item) => {
                  const effectivePrice = getEffectivePrice(item);
                  return (
                    <div className="bm-mini__item" key={item.id}>
                      <div className="bm-mini__thumb">
                        <img src={S3_URL_PRODUCTS + item.images[0]} alt={item.name} />
                        <span className="bm-mini__qty">{item.quantity}</span>
                      </div>
                      <span className="bm-mini__name">{item.name}</span>
                      <span className="bm-mini__price">
                        LKR {formatPrice(effectivePrice * item.quantity)}
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className="bm-lines">
                <div className="bm-line">
                  <span>Subtotal</span>
                  <span>LKR {formatPrice(total)}</span>
                </div>
                {couponDetails && (
                  <div className="bm-line bm-line--discount">
                    <span>Discount ({couponDetails.couponCode})</span>
                    <span>-LKR {formatPrice(discount)}</span>
                  </div>
                )}
                <div className="bm-line">
                  <span>Delivery Fee</span>
                  <DeliveryFeeAmount
                    fee={deliveryFee}
                    status={deliveryFeeStatus}
                    onRetry={loadDeliveryFee}
                  />
                </div>
                {kokoTax > 0 && (
                  <div className="bm-line">
                    <span>Koko Tax</span>
                    <span>LKR {formatPrice(kokoTax)}</span>
                  </div>
                )}
              </div>
              <div className="bm-total">
                <span className="bm-total__label">Total</span>
                <span className="bm-total__value">
                  {deliveryFee === null
                    ? "—"
                    : `LKR ${formatPrice(total - discount + deliveryFee + kokoTax)}`}
                </span>
              </div>
            </div>

            <div className="bm-card">
              <div className="bm-card__head">
                <h2 className="bm-card__title">
                  Payment
                </h2>
              </div>
              <PaymentOptions
                kokoTaxRate={kokoTaxRate}
                kokoTaxRateStatus={kokoTaxRateStatus}
                hasNonCodItem={hasNonCodItem}
                selectedPayment={selectedPayment}
                selectedCardPayment={selectedCardPayment}
                isCardPaymentsExpanded={isCardPaymentsExpanded}
                onPaymentChange={handlePaymentChange}
                onCardPaymentChange={handleCardPaymentChange}
                onSelectCardPayments={() => {
                  setSelectedPayment("cardPayments");
                  setIsCardPaymentsExpanded(true);
                  setSelectedCardPayment("payment5"); // Auto-select OnePay
                }}
              />

              <button type="submit" className="btn btn-main w-100 rounded-8 mt-16 py-14 flex-center gap-8" disabled={isSubmitting}>
                {isSubmitting && (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                {isSubmitting ? "Placing order..." : "Place order"}
                {!isSubmitting && <i className="ph-bold ph-arrow-right" />}
              </button>
              <div className="bm-secure">
                <i className="ph-fill ph-lock-simple" />
                Secure checkout
              </div>
              <p className="bm-legal">
                Your personal data will be used to process your order, support
                your experience throughout this website, and for other purposes
                described in our <Link to="/privacy-policy">privacy policy</Link>.
              </p>
            </div>
          </aside>
        </div>
      </form>
    </section>
  );
};

export default GuestCheckout;
